import { render, staticRenderFns } from "./beneficiary-docs.vue?vue&type=template&id=54896bbe&"
import script from "./beneficiary-docs.vue?vue&type=script&lang=js&"
export * from "./beneficiary-docs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports